@if (chip()) {
  <div class="task-config-chip">
    <proffeo-ui-select
      (valueChange)="setOrderBy($event)"
      [options]="sortByOptions()"
      [value]="orderBy()"
      [showTriggerChevron]="false"
      [triggerTemplate]="sortChipTrigger"
      appearance="inline"
      class="task-config-select"
    />
    <ng-template #sortChipTrigger>
      <span class="task-config-label">{{ 'task-list-sort' | translate }}:</span>
      <strong class="task-config-value">{{ currentSortChipLabel() | translate }}</strong>
      <mat-icon
        aria-hidden="true"
        class="task-config-chevron"
        fontIcon="expand_more"
      />
    </ng-template>

    <button
      (click)="toggleSortDir()"
      [attr.aria-label]="('task-filters.sortDirection' | translate) + ': ' + (sortDirectionLabel() | translate)"
      [matTooltip]="('task-filters.sortDirection' | translate) + ': ' + (sortDirectionLabel() | translate)"
      type="button"
      class="task-config-action task-sort-direction"
    >
      <mat-icon
        [fontIcon]="order() === SortDirection.ASC ? 'arrow_upward' : 'arrow_downward'"
        class="icon-sm"
      />
    </button>
  </div>
} @else {
  <div
    [class.contents]="embedded()"
    [class.flex]="!embedded()"
    [class.max-w-full]="compact() && !embedded()"
    class="min-w-0 items-center w-full gap-0"
  >
    <proffeo-ui-select
      (valueChange)="setOrderBy($event)"
      [options]="sortByOptions()"
      [value]="orderBy()"
      label="task-filters.sortBy"
      class="min-w-0 w-full flex-1"
    />

    <proffeo-ui-button
      (clicked)="toggleSortDir()"
      [ariaLabel]="'task-filters.sortDirection' | translate"
      [fontIcon]="order() === SortDirection.ASC ? 'arrow_upward' : 'arrow_downward'"
      class="w-12 shrink-0"
    />
  </div>
}
